import { combineReducers } from 'redux'

import saveReview from './saveReview'

export default combineReducers({
  saveReview: saveReview
})
